export default function Footer() {
  return (
    <footer id="footer" className="bg-background-800 text-background-200">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          {/* 品牌 */}
          <div>
            <div className="flex items-center gap-2 mb-3">
              <span className="w-8 h-8 flex items-center justify-center">
                <i className="ri-emotion-happy-line text-2xl text-primary-400"></i>
              </span>
              <span className="font-heading text-lg text-background-50">喵趣漫画</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              喵趣漫画网汇集韩漫、日漫与国漫免费全集，支持下拉式在线阅读，让漫画阅读回归纯粹与畅快。
              每日同步更新热门连载，第一时间享受新鲜内容。
            </p>
          </div>

          {/* 快速导航 */}
          <div>
            <h4 className="font-heading text-sm text-background-50 mb-4">
              <a href="#hero" className="no-underline text-background-50 hover:text-primary-400 transition-colors">快速导航</a>
            </h4>
            <ul className="space-y-2.5">
              <li><a href="#carousel" className="text-sm text-background-400 hover:text-primary-400 transition-colors no-underline">精选专题</a></li>
              <li><a href="#ranking" className="text-sm text-background-400 hover:text-primary-400 transition-colors no-underline">人气排行</a></li>
              <li><a href="#faq" className="text-sm text-background-400 hover:text-primary-400 transition-colors no-underline">常见问答</a></li>
              <li><a href="#contact" className="text-sm text-background-400 hover:text-primary-400 transition-colors no-underline">联系投稿</a></li>
            </ul>
          </div>

          {/* 漫画分类 */}
          <div>
            <h4 className="font-heading text-sm text-background-50 mb-4">
              <a href="#index" className="no-underline text-background-50 hover:text-primary-400 transition-colors">漫画分类</a>
            </h4>
            <ul className="space-y-2.5">
              <li><span className="text-sm text-background-400">韩漫全集</span></li>
              <li><span className="text-sm text-background-400">日漫经典</span></li>
              <li><span className="text-sm text-background-400">国漫精选</span></li>
              <li><span className="text-sm text-background-400">下拉式阅读</span></li>
            </ul>
          </div>

          {/* 合作伙伴 */}
          <div>
            <h4 className="font-heading text-sm text-background-50 mb-4">合作伙伴</h4>
            <p className="text-sm text-background-500 leading-relaxed">
              更多合作伙伴即将加入，敬请期待。
            </p>
          </div>
        </div>

        {/* 底部 */}
        <div className="border-t border-background-700 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2026 喵趣漫画网 - 韩漫日漫国漫免费全集 | 下拉式在线阅读
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-background-500">仅供阅读交流</span>
          </div>
        </div>
      </div>
    </footer>
  );
}